import React from 'react';
import { Flex } from '@withjoy/joykit';
import { pxToRem } from '@withjoy/joykit/theme';

import { TextEllipsisWrapper } from '@shared/utils/formatting/textEllipsis';

interface HeaderProps
  extends Readonly<{
    menu?: React.ReactNode;
    distance: React.ReactNode;
  }> {}

export const Header: React.FC<HeaderProps> = ({ menu, distance, children }) => {
  return (
    <Flex
      alignItems="flex-start"
      justifyContent="space-between"
      backgroundColor="white"
      paddingX={4}
      paddingY={3}
      borderRadius={pxToRem(12)}
    >
      <Flex
        flexDirection="column"
        gap={1}
        flex={1}
      >
        <TextEllipsisWrapper
          typographyVariant="hed2"
          fontFamily="Inter UI"
          fontWeight={600}
          color="mono14"
        >
          {children}
        </TextEllipsisWrapper>
        {distance}
      </Flex>
      {menu}
    </Flex>
  );
};
